import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table'; 
import { CommonModule } from '@angular/common'; 
import { FormsModule } from '@angular/forms'; 
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ISearchCriteria, IResult } from '../../../interface/delegationofauthority/doa';
import { RoleGuardService } from '@cvx/cal-angular';
import { Router } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LookupComponent } from '../../../shared/component/look-up/lookup.component';
import { SharedServices } from '../../../shared/services/shared.services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DisplaypageComponent } from '../displaypage/displaypage.component';

@Component({
  selector: 'app-getemployees',
  standalone: true,
  imports: [
    CommonModule, 
    MatPaginatorModule, 
    MatSortModule, 
    MatTableModule, 
    FormsModule, 
    MatProgressSpinnerModule,
    LookupComponent
  ],
  templateUrl: './getemployees.component.html',
  styleUrls: ['./getemployees.component.css'],
})
export class GetemployeesComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['SrNo' ,'name', 'jobtitle', 'deptcode'];
  dataSource = new MatTableDataSource<any>([]);
  error: string | null = null;
  ismatTableData: boolean= false;
  submitFormFlag: boolean= false;
  searchByPattern: string = '.*'; 
  searchCriteria = {
    searchBy: 'Name',
    entervalue: '',
    sortResultBy: 'Name',
    sortOrder: 'asc',
  }; 
  isLoading: boolean = false;
  showPaginator: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private delegationService: DelegationofauthorityService,private dialog: MatDialog, private sharedService: SharedServices,private router:Router ) {}

  ngOnInit(): void {
    this.ismatTableData = false;
    this.isLoading = false;
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  onFieldChange() {
    this.searchCriteria.entervalue = '';
    if (this.searchCriteria.searchBy === 'Deptcode' || this.searchCriteria.searchBy === 'EmpNo') {
      this.searchByPattern = '^[0-9]*$'; 
    } else {
      this.searchByPattern = '.*'; 
    }
  }

  onLookupSelect(selectedItem: any) {
    this.searchCriteria.entervalue = selectedItem.emailAddress || selectedItem.employeeNo;
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  validateInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (this.searchByPattern === '^[0-9]*$') {
      inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
      this.searchCriteria.entervalue = inputElement.value;
    }
  }

  submit(): void {
    if(this.submitFormFlag){
    this.isLoading = true; 
    if (this.searchCriteria.entervalue.trim() === '' && !this.searchCriteria.searchBy && !this.searchCriteria.sortResultBy && !this.searchCriteria.sortOrder) {      
      this.sharedService.openModal('Message', 'Please all select field.');       
      this.isLoading = false; 
      return;
    }
    if (this.searchCriteria.entervalue.trim() === ''||!this.searchCriteria.searchBy || !this.searchCriteria.sortResultBy || !this.searchCriteria.sortOrder) {      
      this.sharedService.openModal('Message', 'Please all select field.');       
      this.isLoading = false; 
      return;
    }
    this.delegationService.getEmployeeDOA(
        this.searchCriteria.searchBy,
        this.searchCriteria.entervalue,
        this.searchCriteria.sortResultBy,
        this.searchCriteria.sortOrder
      )
      .subscribe({
        next: (data) => {
          this.isLoading = false; 
          if (data && data.length > 0) {
            this.dataSource.data = data;
            this.error = null;
            this.ismatTableData = true;
            this.showPaginator = true;
          } else {
            this.error = 'No match record found!';
            this.dataSource.data = [];
            this.ismatTableData = false;
            this.showPaginator = false;
          }
        }, 
        error: () => {
          this.isLoading = false;
          this.error = 'No match record found!';
          this.dataSource.data = [];
          this.ismatTableData = false;
          this.showPaginator = false;
        },
      });
    }
  }

  navigateToDOA() {
    window.location.href = '/DOA';
  }

}
